import { userSelector } from './userSelector';

export const orderSelector = (state, orderId) => {
  const order = state.order.items[orderId];
  if (order) {
    const purchaser = userSelector(state, order.fk_purchaser_id);
    return { ...order, purchaser };
  }
};
